<template>
    <div class="col-md-12 mx-auto">
        <div class="card">
            <div class="card-header card-header bg-primary text-white h5 m-0">
                <page-title :title="($t('publicOrder.title'))"></page-title>
            </div>
        </div>

        <kendo-tabstrip @activate="onTabActivate">
            <ul>
                <li class="k-state-active" id="activeOrdersTab">
                    {{ $t('publicOrder.title') }}
                </li>
                <li id="archiveTab">
                    {{ $t('publicOrder.archive') }}
                </li>
            </ul>
            <div>
                <active-public-orders v-if="activeTabActive">
                </active-public-orders>
            </div>
            <div>
                <archive-public-orders v-if="archiveTabActive">
                </archive-public-orders>
            </div>
        </kendo-tabstrip>
    </div>
</template>

<script>
    import Vue from 'vue';
    import PageTitle from '../../../components/common/PageTitle';
    import ActivePublicOrders from "./ActivePublicOrdersPublicList.vue";
    import ArchivePublicOrders from "./ArchivePublicList";
    import { LayoutInstaller } from '@progress/kendo-layout-vue-wrapper';

    Vue.use(LayoutInstaller);

    export default {
        inject: ['$validator'],
        components: {
            PageTitle,
            ActivePublicOrders,
            ArchivePublicOrders,
        },
        data() {
            return {
                activeTabActive: true,
                archiveTabActive: false,
            };
        },
        methods: {
            onTabActivate(e) {
                const tabId = e.item.id;
                if (!tabId) {
                    return;
                }

                switch (tabId) {
                    case "activeOrdersTab":
                        this.resetAllTabs();
                        this.activeTabActive = true;
                        break;
                    case "archiveTab":
                        this.resetAllTabs();
                        this.archiveTabActive = true;
                        break;
                    default:
                        break
                }
            },
            resetAllTabs() {
                this.activeTabActive = false;
                this.archiveTabActive = false;
            }
        },
        mounted: function () {
        },
        computed: {}
    }
</script>

<style scoped>
</style>
